<div class="flex flex-col gap-4" [class]="direction">
  <mot-button-toggle
    [options]="departureTimeOpts$"
    [formControl]="timeOptFormControl"
    [groupAriaLabel]="tripTimeModeGroupLabel"
    class="w-full"
    toggleClass="min-[22.1875rem]:px-4 !border-0 !flex-1"
  ></mot-button-toggle>

  @if (timeOptFormControl.value != eTimeOptions.NOW) {
    <div
      class="w-full"
      >
      @switch (timeOptFormControl.value) {
        @case (eTimeOptions.DEPART) {
          <ng-container
        *ngTemplateOutlet="
          timePickForm;
          context: { $implicit: departureFormGroup }
        "
          ></ng-container>
        }
        @case (eTimeOptions.ARRIVAL) {
          <ng-container
        *ngTemplateOutlet="
          timePickForm;
          context: { $implicit: arrivalFormGroup }
        "
          ></ng-container>
        }
      }
    </div>
  }
</div>

<ng-template #timePickForm let-data>
  <form [formGroup]="data" class="flex flex-col gap-4">
    <mot-date-picker
      formControlName="date"
      [label]="dateText"
      [minDate]="today"
      [maxDate]="maxDate"
      class="w-full"
    ></mot-date-picker>
    <mot-time-picker
      formControlName="time"
      [label]="timeText"
      icon="clock"
      iconClass="text-2xl"
      class="w-full"
      />
      @if (isDesktop) {
        <!-- contrast: #6f7277 ~4.3:1 fell just below AA 4.5:1; subText (#5C748F, ~4.9:1) passes. -->
        <span class="text-sm text-subText">{{typeTime24HoursText}}</span>
      }
    </form>
  </ng-template>
